import { isAfter, format, parseISO } from 'date-fns';
import { isNil } from 'lodash';

export const formSignedAgainRecently = (form: any) => {
  const adminStatusDate = form.metadata?.statusDate;
  const productSignedDate = form.signedAt;
  const borrowerRecentlyUpdated =
    adminStatusDate &&
    productSignedDate &&
    isAfter(new Date(productSignedDate), new Date(adminStatusDate));

  return borrowerRecentlyUpdated;
};

export const formatStartDate = (employerStartDate: any) =>
  !isNil(employerStartDate)
    ? format(parseISO(employerStartDate), 'LLL yyyy')
    : 'Missing Start Date';
export const formatEndDate = (employerEndDate: any) =>
  !isNil(employerEndDate)
    ? format(parseISO(employerEndDate), 'LLL yyyy')
    : 'Present';
export const calcDuration = (employerStartDate: any, employerEndDate: any) =>
  isNil(employerStartDate) && isNil(employerEndDate)
    ? '-'
    : `${formatStartDate(employerStartDate)}-${formatEndDate(employerEndDate)}`;

export const signatureStatus = (signRequests: any) => {
  let status = '-';

  signRequests.forEach((req: any) => {
    if (req?.role === 'employer' && req.complete) {
      status = 'All Signed';
    }
  });

  return status;
};
